<template>
    <div>
        <div>
            <div class="d-flex flex-column question mb-2">
                <div class="text-muted mr-1 mb-1">Question:</div>
                <TipTap
                    v-model="question.content.question"
                    :menu_items="[]"
                    :readonly="true"
                />
            </div>
        </div>

        <div class="d-flex flex-column suggest-answer">
            <div class="text-muted mr-1 mb-1">Suggested Answer:</div>
            <TipTap
                v-model="question.content.suggested_answer"
                :menu_items="[]"
                :readonly="true"
            />
        </div>

        <div
            v-if="question.content.image.src"
            class="d-flex flex-column suggest-answer"
            :class="{'merlin-asset-border': isMerlinMedia}"
        >
            <div v-if="isMerlinMedia" class="merlin-asset-wrapper">
                <span class="merlin-asset-warning">
                    <font-awesome-icon :icon="['fas', 'exclamation-triangle']" fixed-width />
                    Merlin Asset
                </span>
            </div>

            <div class="text-muted mr-1 mb-1">Answer Background Image:</div>
            <img
                style="height: auto; width: 300px;"
                :alt="question.content.image.alt"
                :src="question.content.image.src"
            />
        </div>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
export default {
    data: () => ({}),
    props: ['question', 'question_html'],
    components: {
        TipTap: () => import('@/components/tiptap/TipTap')
    },
    computed: {
        isMerlinMedia() {
            const questionHasContent = this.question && this.question.content
            const questionContentHasImage = this.question.content.image && this.question.content.image.src
            if (!questionHasContent || !questionContentHasImage) {
                return false
            }
            return this.question.content.image.src.toLowerCase().includes('merlinone')
        },
    }
}
</script>
